import { ServicetypeList } from 'src/app/shared/models/job-service-type-list.model';
import { PostJobsServiceNavigationSubMenu } from '../../../shared/models/gql/post-jobs-service-navigation-sub-menu.model';
import { PostJobsServiceNavigation } from '../../../shared/models/gql/post-jobs-service-navigation.model';

export const postJobsServiceNavigationSubMenu: PostJobsServiceNavigationSubMenu[] = [
  {
    name: 'Support activities',
    value: 'supportActivities',
    parentNavValue: 'whereAndWhat',
    link: '/support-activities',
    isShown: true,
    isCompleted: false,
  },
  {
    name: 'Daily living, social and community activities',
    value: 'dailyLivingSocialAndCommunity',
    parentNavValue: 'whereAndWhat',
    link: '/daily-living-social-community',
    isShown: false,
    isCompleted: false,
  },
  {
    name: 'Personal care',
    value: 'personalCare',
    parentNavValue: 'whereAndWhat',
    link: '/personal-care',
    isShown: false,
    isCompleted: false,
  },
  {
    name: 'Allied health',
    value: 'alliedHealth',
    parentNavValue: 'whereAndWhat',
    link: '/allied-health',
    isShown: false,
    isCompleted: false,
  },
  {
    name: 'Social and community support details',
    value: 'socialAndCommunitySupportDetails',
    parentNavValue: 'whereAndWhat',
    link: '/social-and-community-support-details',
    isShown: false,
    isCompleted: false,
  },
  {
    name: 'Transport details',
    value: 'transportDetails',
    parentNavValue: 'whereAndWhat',
    link: '/transport-details',
    isShown: false,
    isCompleted: false,
  },
  {
    name: 'Light housework details',
    value: 'lightHouseworkDetails',
    parentNavValue: 'whereAndWhat',
    link: '/light-housework-details',
    isShown: false,
    isCompleted: false,
  },
  {
    name: 'Location',
    value: 'location',
    parentNavValue: 'when',
    link: '/location',
    isShown: true,
    isCompleted: false,
  },
  {
    name: 'Frequency, dates and times',
    value: 'frequencyDatesAndTimes',
    parentNavValue: 'when',
    link: '/frequency-dates-times',
    isShown: true,
    isCompleted: false,
  },
  {
    name: 'Basic information',
    value: 'basicInformation',
    parentNavValue: 'details',
    link: '/basic-information',
    isShown: false,
    isCompleted: false,
  },
  {
    name: 'Support details',
    value: 'supportDetails',
    parentNavValue: 'details',
    link: '/support-details',
    isShown: true,
    isCompleted: false,
  },
  {
    name: 'Preferences',
    value: 'preferences',
    parentNavValue: 'details',
    link: '/preferences',
    isShown: false,
    isCompleted: false,
  },
  {
    name: 'Review and post',
    value: 'reviewAndPost',
    parentNavValue: 'preview',
    link: '/review-job',
    isShown: true,
    isCompleted: false,
  },
];

export const postJobsServiceNavigation: PostJobsServiceNavigation[] = [
  {
    name: 'What',
    value: 'whereAndWhat',
    isCollapsed: true,
    isCompleted: false,
    subNavigation: [],
  },
  {
    name: 'Where and When',
    value: 'when',
    isCollapsed: false,
    isCompleted: false,
    subNavigation: [],
  },
  {
    name: 'Details',
    value: 'details',
    isCollapsed: false,
    isCompleted: false,
    subNavigation: [],
  },
  {
    name: 'Preview',
    value: 'preview',
    isCollapsed: false,
    isCompleted: false,
    subNavigation: [],
  },
];

export const navigationValueMappingJobObj = {
  dailyLivingSocialAndCommunity: ['basicSocial'],
  personalCare: ['basicPersonal'],
  transportDetails: ['basic_transport'],
  lightHouseworkDetails: ['basic_housework'],
  socialAndCommunitySupportDetails: ['basic_community', 'basic_companionship'],
};

export const SERVICE_TYPE_LIST: ServicetypeList[] = [
  {
    title: 'Daily living, social and community activities',
    value: 'basic_social',
    src: 'assets/img/mable/careType_dailyLiving.svg',
    showShield: false,
    details: 'Social support, housework, transport, meal prep and more.',
  },
  {
    title: 'Personal care',
    subtitle: 'Qualifications verified',
    workerQualification: 'Worker qualifications are verified',
    value: 'basic_personal',
    src: 'assets/img/mable/careType_personalCare.svg',
    showShield: true,
    details: 'Showering, hoist and transfer, assistance with medication and more.',
  },
  {
    title: 'Nursing',
    subtitle: 'Qualifications verified',
    workerQualification: 'Worker qualifications are verified',
    value: 'basic_nurse',
    src: 'assets/img/mable/careType_nursing.svg',
    showShield: true,
    details: 'Wound care, catheter care and more.',
  },
  {
    title: 'Allied health',
    subtitle: 'Qualifications verified',
    workerQualification: 'Worker qualifications are verified',
    value: 'basic_allied',
    src: 'assets/img/mable/careType_allied.svg',
    showShield: true,
    details: 'Occupational therapy, psychology, physiotherapy and speech therapy.',
  },
];

/**
 * The query parameter for tracking which event triggered the job creation.
 *
 * Since source param is always "ready made jobs" for express jobs, this means that the origin
 * will be used to track which actual event triggered the job creation.
 *
 * If this is available, the value will be included in drafts and the creation of jobs.
 */
export const POSTJOB_ORIGIN_QUERY_PARAM = 'origin';

/**
 * The query parameter for tracking where job creation has been initiated.
 *
 * If this is available, the value will be included in the creation of jobs.
 */
export const POSTJOB_SOURCE_QUERY_PARAM = 'source';

/**
 * The query parameter for replacement jobs from cancelled scheduled events.
 */
export const SCHEDULED_EVENT_DERIVED_UNIQUE_ID_PARAM = 'scheduledEventDerivedUniqueId';

/**
 * The query parameter for replacement jobs from cancelled scheduled events.
 */
export const SCHEDULED_EVENT_OCCURRENCE_ID_PARAM = 'scheduledEventOccurrenceId';
